import styled from 'styled-components'
import pxToRem from '../../../../utils/pxToRem'
import { NAVBAR_HEIGHT } from '../../../../theme/constants'

export const StyledNavList = styled.ul.attrs(props => ({
      className: props.className,

    }))`
    
    & .slide-in-active {
        transform: translate3d(0, 0, 0);
    }
    
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    position: absolute;
    background-color: ${({ theme }) => theme.colors.secondary.grey95};
    ${({ isSubNav }) => {
        if (isSubNav) return `
                  top: 0;
                  transform: translate3d(100%, 0, 0);
                  transition: transform 0.5s ease-out;
              `;
        return '';
      }}
    ${({ isColored, theme }) => {
      if (isColored === 'black') return `
                background-color: ${theme.colors.unique.black};
            `;
      if (isColored === 'white') return `
                background-color: ${theme.colors.unique.white};     
            `;
      return '';
    }}
`

export const StyledNavTitle = styled.h2`
    display: flex;
    align-items: center;
    height: ${pxToRem(64)};
    font-size: ${pxToRem(20)};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    color: ${({ theme }) => theme.colors.unique.black};
    background-color: ${({ theme }) => theme.colors.secondary.grey95};
    padding-inline: ${pxToRem(20)} ${pxToRem(10)};
`

export const StyledNavTitleContainer = styled.div`
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.secondary.grey95};
`

export const StyledNavListItemContainer = styled.div`
    display: block;
    overflow-y: auto ;
    height: calc(100vh - ${ NAVBAR_HEIGHT.mobile}px);
    
    ::-webkit-scrollbar {
        width: 4px;
        height: 4px;
    }
`